import imageCompression from "browser-image-compression";

/**
 * 压缩图片到目标体积以内。
 * @param {File|Blob} file
 * @param {{ maxSizeMB: number, maxWidthOrHeight?: number, fileName?: string }} options
 * @returns {Promise<File>}
 */
export async function compressImage(file, options) {
  const maxSizeMB = options.maxSizeMB;
  const maxWidthOrHeight = options.maxWidthOrHeight ?? 1920;
  const input =
    file instanceof File
      ? file
      : new File([file], options.fileName || "image.jpg", {
          type: file.type || "image/jpeg",
        });

  if (input.size <= maxSizeMB * 1024 * 1024) {
    return input;
  }

  const compressed = await imageCompression(input, {
    maxSizeMB,
    maxWidthOrHeight,
    useWebWorker: true,
    initialQuality: 0.8,
  });

  if (compressed instanceof File) {
    return compressed;
  }
  return new File([compressed], input.name || options.fileName || "image.jpg", {
    type: compressed.type || input.type || "image/jpeg",
  });
}

export function formatSizeMB(bytes) {
  return (bytes / (1024 * 1024)).toFixed(2);
}
